module.exports = __webpack_public_path__ + "static/media/calendar.32f5cf0c.svg";